<template>
  <div class="sidebar-user">
    <s-button color="primary" icon="mdiAccountCircle" variant="icon" @click="openModal" />

    <transition>
      <div class="sidebar-user-text" v-if="drawer">
        <div @click="openModal">
          <b>{{ firstName }}</b>
        </div>
        <s-button color="primary" icon="mdiLogout" variant="icon" @click="logout" />
      </div>
    </transition>
    
    <lazy-modal-usuario-auth v-model="modelValue" :user_id="user_id"  />
  </div>
</template>

<script lang="ts" setup>
import type { Usuario } from '~/@types/schemas/usuario';

const modelValue = ref(false);
const user_id = ref<number | string | null>(null);

interface UserProps {
  drawer: boolean;
  user: Usuario;
  logout: () => void;
}

const openModal = () => {
  modelValue.value = true
  user_id.value = props.user.id!
}   

const props = defineProps<UserProps>();

const firstName = computed(() => {
  return props.user.nome.split(' ')[0]
});

</script>